/* RESPONSIBLE TEAM: team-proactive-support */
import Model, { attr } from '@ember-data/model';

export default class OutboundCustomerTwilioCredentials extends Model {
  @attr('string') accountSID;
  @attr('string') authToken;
}
